var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('h1',[_vm._v("欢迎使用职业健康培训平台")])])
}]

export { render, staticRenderFns }